import { mergeAttributes } from "@tiptap/core";
import TiptapLink from "@tiptap/extension-link";
import { Plugin } from "@tiptap/pm/state";
import { EditorView } from "@tiptap/pm/view";

export const Link = TiptapLink.extend({
    inclusive: false,

    parseHTML() {
        return [{ tag: 'a[href]:not([data-type="button"]):not([href *= "javascript:" i])' }];
    },

    renderHTML({ HTMLAttributes }) {
        return [
            "a",
            mergeAttributes(
                this.options.HTMLAttributes,
                HTMLAttributes,
                { class: "link" },
                // we add `data-prevent-progress` attribute to anchor tag so that `bprogress` won't run when link is clicked
                // https://github.com/Skyleen77/bprogress/blob/f60885d09b0d8fa2e8695bd8c709e88151512639/packages/react/src/hooks/use-anchor-progress.tsx#L75C50-L75C71
                { "data-prevent-progress": true }
            ),
            0,
        ];
    },

    addProseMirrorPlugins() {
        const { editor } = this;

        return [
            ...(this.parent?.() || []),
            new Plugin({
                props: {
                    handleKeyDown: (_view: EditorView, event: KeyboardEvent) => {
                        const { selection } = editor.state;

                        if (event.key === "Escape" && selection.empty !== true) {
                            editor.commands.focus(selection.to, { scrollIntoView: false });
                        }

                        return false;
                    },
                },
            }),
        ];
    },
});

export default Link;
